import React, { useEffect } from "react";
import "../../styles/contact/Contact.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";

export default function Contact(props) {
  const { t } = useTranslation();
  const contactInfo = [
    {
      id: 1,
      title: t('contactInfo.Informations'),
      paragraph: t('contactInfo.Informations_paragraph'),
    },
    {
      id: 2,
      paragraph: "+212 (0) 5 30 16 47 99",
      paragraph1: "+212 (0) 6 08 11 21 12",
    },
    {
      id: 3,
      paragraph1: "support@afrogotech.ma",
      paragraph2: "contact@afrogotech.ma",
    },
    {
      id: 4,
      paragraph: "N° 306, 10 Rue Ghandi,",
      paragraph1: "Rabat 10000",
    },
  ];
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div className="Contact--container" id="contact-us">
      <h1 className="Contact-title">
        {t('contactInfo.title')} <span className="SpanHighlightBlue">{t('contactInfo.title_2')}</span>
      </h1>
      <div className="Contact-form">
        <form className="form"  action="https://formsubmit.co/77a8b6c97510f429fae14ee631564a5f" method="POST" id="Contact-form">
          <div className="flex">
            <label>
              <input className="input" type="text" name="name" placeholder={true} required={true} />
              <span>{t("contactInfo.nom")}</span>
            </label>
            <label>
              <input className="input" type="text" name="organisation" placeholder={true} required={true} />
              <span>organisation</span>
            </label>
          </div>
          <div className="flex">
            <label>
              <input className="input" type="number" name="phone" placeholder={true} required={true} />
              <span>{t("contactInfo.telephone")}</span>
            </label>
            <label>
              <input className="input" type="email" name="email" placeholder={true} required={true} />
              <span>e-mail</span>
            </label>
          </div>
          <label>
            <input className="input" placeholder={true} type="text" name="Object" required={true} />
            <span>{t("contactInfo.objet")}</span>
          </label>
          <label>
            <textarea
              className="input01"
              placeholder
              rows={3}
              required
              defaultValue={""}
              name="message"
            />
            <span>message</span>
          </label>
          <button type="submit" className="fancy">
            <span className="top-key" />
            <span className="text">{t("contactInfo.envoyer")}</span>
            <span className="bottom-key-1" />
            <span className="bottom-key-2" />
          </button>
        </form>
        <div className="Contact-form_infortmation" >
          {contactInfo.map((info, index) => {
            return (
              <div className="information" key={index}>
                <h4>{info.title}</h4>
                <p>{info.paragraph}</p>
                <p>{info.paragraph1}</p>
                <p>{info.paragraph2}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
